
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, IconButton, Stack } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import FileList from '../../../Components/cra/FileList';
import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { AjoutDeduire } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import MultipleFilesUpload from '../../../Utils/fileUpload/MultipleFileUpload';
import { getNomPrenomClearFromPersoData, isHttpStatusSuccess } from '../../../Utils/utils';
import { calculateMontantTotalAstreintesReg, calculateMontantTotalHnosReg, calculateMontantTotalNoteFrais, calculateMontantTotalOfOneAstreinteReg, calculateMontantTotalOfOneHnoReg, calculateMontantTotalReg, filesAddapter, initializeAstreinteRegularisation, initializeHNORegularisation, initializeNotesFrais } from '../../../Utils/utilsCraX';
import NomRefRgularisationNormal from './NomRefRgularisationNormal';

const RegularizationPC = () => {
    const { state } = useLocation();
    const role = useRole();
    const [fileList, setFileList] = useState([]);
    const [refCra, setRefCra] = useState('');
    const [craXId, setCraXId] = useState('');
    const [refMission, setRefMission] = useState('');
    const [nomClient, setNomClient] = useState('');
    const [refClient, setRefClient] = useState('');
    const [refExpert, setRefExpert] = useState('');
    const [nomExpert, setNomExpert] = useState('');
    const [refIntClient, setRefIntClient] = useState('');
    const [refCmdClient, setRefCmdClient] = useState('');
    const [astreintes, setAstreintes] = useState([]);
    const [hnos, setHnos] = useState([]);
    const { postDataSilently } = usePostRequest();
    // const [data,setData]=useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [prestationsComplementairesCLientData, setPrestationsComplementairesCLientData] = useState([]);
    const [notesFrais, setNotesFrais] = useState([]);
    const [tj, setTj] = useState(0);
    const {device}=useWindowSize();
    const [note, setNote] = useState('');
    let navigate = useNavigate();
    const [isMontant,setIsMontant]=useState(true);
    const [nbrHrHno,setNbrHrHno]=useState(8);
    const { i18n } = useTranslation();
    const [tjClient, setTjClient] = useState(0);
    //const role = useRole();
    //const totalAstreintes = useMemo(() => calculateMontantTotalAstreintesReg(astreintes), [astreintes]);
    const totalHnosExpert = useMemo(() => calculateMontantTotalHnosReg({ hnosFileList: hnos, tj: tj, role: 'expert', tjClient: tjClient , nbrHrHno:nbrHrHno}), [hnos]);
    const totalHnosClient = useMemo(() => calculateMontantTotalHnosReg({ hnosFileList: hnos, tj: tj, role: 'client', tjClient: tjClient , nbrHrHno:nbrHrHno}), [hnos]);
    const totalNotesFrais = useMemo(() => calculateMontantTotalNoteFrais(notesFrais), [notesFrais]);
    const totalAstreintesExpert = useMemo(() => calculateMontantTotalAstreintesReg({astreintesFileList:astreintes,isMontant, role: 'expert',tj,tjClient}), [astreintes]);
    const totalAstreintesClient = useMemo(() => calculateMontantTotalAstreintesReg({astreintesFileList:astreintes,isMontant, role: 'client',tj,tjClient}), [astreintes]);
    const montantTotalExpert = useMemo(() => calculateMontantTotalReg({
        astreintesFileList: astreintes,
        hnosFileList: hnos,
        notesFraisFileList: notesFrais,
        tj: tj,
        role: 'expert',
        tjClient: tjClient,
        isMontant:isMontant,
        nbrHrHno:nbrHrHno
    }), [astreintes, hnos, notesFrais]);

    const montantTotalClient = useMemo(() => calculateMontantTotalReg({
        astreintesFileList: astreintes,
        hnosFileList: hnos,
        notesFraisFileList: notesFrais,
        tj: tj,
        role: 'client',
        tjClient: tjClient,
        isMontant:isMontant,
        nbrHrHno:nbrHrHno
    }), [astreintes, hnos, notesFrais]);

    //const totalNotesFrais = useMemo(() => calculateMontantTotalNoteFrais(notesFrais), [notesFrais]);
    //const montantTotal = useMemo(() => calculateMontantTotal({
    //    astreintesFileList: astreintes,
    //    hnosFileList: hnos,
    //    notesFraisFileList: notesFrais,
    //    tj: tj,
    //    role: role,
    //    tjClient: tjClient
    //}), [notesFrais, hnos, notesFrais]);

    //const [notesFrais, setNotesFrais] = useState([initializeNotesFrais(0)]);
    useEffect(() => {
        if (refCra && (!state?.rowData?.refCra)) {
            getCraXByCraRef(refCra);
        }
    }, [refCra]);

    useEffect(() => {
        //TODO: to complete later on, those are the first steps to do an update by the admin, starting by loading the right data
        if (state?.rowData?.refCra) {
            // const regularisationX = state?.rowData;
            // alert(JSON.stringify(state?.rowData?.files));
            console.log('refCra', state?.rowData?.refCra);
            console.log('state.rowData',state?.rowData);
            initializeCraX(state?.rowData[state?.rowData?.isCraOrCraX]);
            setRefIntClient(state?.rowData?.refIntClient);
            // setCraX(craX);
            setAstreintes(state?.rowData?.astreintes);
            setHnos(state?.rowData?.hnos);
            setNotesFrais(state?.rowData?.notesFrais);
            setNote(state?.rowData?.note);
            setFileList(filesAddapter(state?.rowData?.files));
        }
    }, [state]);

    // useEffect(() => {
    //     if (data) {
    //         initializeCraX(data);
    //     }
    // }, [data]);

    const getClientPrestationComplementaireData = async (companyDataId,role) => {
        const response1 = await postDataSilently({
            url: `/${role}/getClientPrestationComplementaireData`,
            payload: {
                companyDataId
            }
        });

        var astreintes = [];
        var hnos = [];

        response1.data?.prestationsComplementaires?.astreintes?.map((element) => {
            astreintes.push({ _id: element?._id, montant: element?.montant, label: element?.type, value: element?.type });
        });

        response1.data?.prestationsComplementaires?.hnos?.map((element) => {
            hnos.push({ _id: element?._id, montant: element?.montant, label: element?.type, value: element?.type });
        });

        console.log('prestationsComplementairesCLientData', response1.data?.prestationsComplementaires?.astreintes);
        setPrestationsComplementairesCLientData({ astreintes: astreintes, hnos: hnos });
    };

    const getCraXByCraRef = async (refCra) => {
        try {
            //TS-202020 pour le test
            const response = await axiosPrivate.get('/cra/getCraXByRef/' + refCra);
            // setData(response?.data);
            initializeCraX(response?.data);
        } catch (error) {
            console.log(error);
            if (error?.response?.status == 400) {
                Swal.fire({
                    icon: 'error',
                    // title: 'Oops...',
                    text: i18n.t(error?.response?.data?.error),
                });
            }
            // setData([]);
        }
    };

    const initializeCraX = async (craX) => {
        // alert(craX?.craXId);
        setRefCra(craX?.craXId);
        setCraXId(craX?._id);
        setRefMission(craX?.missionId?.missionId);
        setRefClient(craX?.missionId?.companyDataId?.clientId ?? craX?.missionId?.esnId?.esnId);
        setNomClient(craX?.missionId?.companyDataId?.profileEntreprise?.nom ?? craX?.missionId?.esnId?.profileEntreprise?.nom );
        setRefExpert(craX?.missionId?.expertId?.expertId);
        // setRefIntClient(craX?.refIntClient);
        setRefCmdClient(craX?.bdcId?.refCmdClient);
        setNomExpert(getNomPrenomClearFromPersoData(craX?.missionId?.expertId?.persoData));
        getClientPrestationComplementaireData(craX?.missionId?.companyDataId?._id ?? craX?.missionId?.esnId?._id,craX?.missionId?.companyDataId?._id ? 'client' :'esn');
        setTj(craX?.tj);
        setTjClient(craX?.tjClient);
        if(craX?.rules?.isMontant!=undefined)
            setIsMontant(craX?.rules?.isMontant);
        if(craX?.rules?.nbrHrsHNOs)
            setNbrHrHno(craX?.rules?.nbrHrsHNOs);

    };
    const createRegularisationX = async () => {
        try {
            const formData = new FormData();
            formData.append('craXId', craXId); // data?._id
            // *calculs
            formData.append('totalAstreintesClient', totalAstreintesClient);
            formData.append('totalAstreintes', totalAstreintesExpert);
            formData.append('totalHnos', totalHnosExpert),
            formData.append('totalHnosClient', totalHnosClient),
            formData.append('totalNotesFrais', totalNotesFrais),
            formData.append('montantTotal', montantTotalExpert);
            formData.append('montantTotalClient', montantTotalClient);
            formData.append('astreintes', JSON.stringify(astreintes));
            formData.append('hnos', JSON.stringify(hnos));
            formData.append('notesFrais', JSON.stringify(notesFrais));
            formData.append('note', note);
            let existedFilesTemp = [];
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i]?.isFromBackend) {
                    existedFilesTemp.push(fileList[i]);
                }
                else { formData.append(`craXFile${i}`, fileList[i]); }
            }
            formData.append('existedFilesOnBackend', JSON.stringify(existedFilesTemp));
            // for (let i = 0; i < fileList.length; i++) {
            //     formData.append(`craXFile${i}`, fileList[i]);
            // }
            const response1 = await postDataSilently({
                url: 'facture/createRegularisationX',
                payload: formData,
            });
            console.log('response1',response1);
            // Continue with the second request if the first request is successful
            const response2= await axiosPrivate.post('/facture/updateRefIntClient', {
                'refIntClient': refIntClient,
                'type': 'regularisation',
                'craXId': craXId,
            });
            console.log('response2 statusCode',response2,response2?.responseStatus);

            if(isHttpStatusSuccess(response2?.status)){
                console.log(response2);
                // Assuming success, show success message and navigate
                Swal.fire({
                    icon: 'success',
                    text: state?.rowData?.refCra ?
                        i18n.t('La régularisation de la prestation complémentaire a été mise à jour') :
                        i18n.t('La régularisation de la PC a été créée avec succès'),
                    confirmButtonColor: '#5CC889',
                });
                navigate(-1);
            }
        } catch (error) {
            console.log(error, error?.response?.status);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: i18n.t(error?.response?.data?.error),
            });
            navigate(-1);
        }
        //updateCraX(response1?.data?.createdCraX??response1?.data?.updatedCraX);

    };

    const disabledParam = (role == 'client' || role == 'expert'||role=='esn');
    return (
        <form style={{ alignSelf: 'stretch', gap: '24px', display: 'flex', flexDirection: 'column' }}>
            <h4 className='titlesociete'>
                {role == 'admin' ? (state?.rowData?.refCra ? i18n.t('Modifier la régularisation-Prestation complémentaire') : i18n.t('Faire une régularisation-Prestation complémentaire')) : i18n.t('Régularisation-Prestation complémentaire')}
            </h4>
            {/* // {state?.rowData?.refCra ?? ' '} */}
            <NomRefRgularisationNormal
                refCra={refCra}
                setRefCra={setRefCra}
                refMission={refMission}
                nomClient={nomClient}
                refClient={refClient}
                refExpert={refExpert}
                nomExpert={nomExpert}
                refCmdClient={refCmdClient}
                refIntClient={refIntClient}
                setRefIntClient={setRefIntClient}
                mode={disabledParam ? 'readOnly' : ''}
            />
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Astreintes')}
                </h6>
                {Array.isArray(astreintes) && astreintes.map((astreinte, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type d\'astreinte')} </label>
                            <SelectComponent
                                val={astreinte?.type}
                                setVal={(e) => {
                                    let newArr = [...astreintes];
                                    newArr[i].type = e.target.value;
                                    newArr[i].montantUnit = prestationsComplementairesCLientData?.astreintes?.find(item => item.label === e.target.value)?.montant;
                                    setAstreintes(newArr);
                                    console.log(e.target.value);
                                }}
                                listVal={prestationsComplementairesCLientData?.astreintes}
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'> {i18n.t('Ajouter/déduire')} </label>
                            <SelectComponent
                                //val={typeDiplome}
                                name='typeDiplome'
                                // defaultValue={astreinte?.ajout}
                                val={astreinte?.ajout}
                                setVal={(e) => {
                                    let newArr = [...astreintes];
                                    newArr[i].ajout = e.target.value;
                                    setAstreintes(newArr);
                                    console.log(e.target.value);
                                }}
                                listVal={AjoutDeduire}
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Nombre d\'astreintes')} </label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={astreinte?.nbrAstreintes}
                                onChange={(e) => {
                                    let newArr = [...astreintes];
                                    newArr[i].nbrAstreintes = e.target.value;
                                    setAstreintes(newArr);
                                    console.log(e.target.value);
                                }}
                                name="tauxJournalierExpert"
                                disabled={disabledParam}
                            />
                        </div>
                        {role != 'expert' &&
                            <div
                                className="FrameBox4Reg"
                                style={role == 'client' ? {width:device=='desktop'?'25%':'100%'} : {width:device=='desktop'?'20%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Montant/Client')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    value={calculateMontantTotalOfOneAstreinteReg({astreinte,isMontant,role:'client',tj,tjClient}).toFixed(2)}
                                    iconEnd={'€'}
                                    disabled
                                />
                            </div>}
                        {role != 'client' &&
                            <div
                                className="FrameBox4Reg"
                                style={role == 'expert' ? {width:device=='desktop'?'25%':'100%'} : {width:device=='desktop'?'20%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Montant/Expert')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    value={calculateMontantTotalOfOneAstreinteReg({astreinte,isMontant,role:'expert',tj,tjClient}).toFixed(2)}
                                    //InputProps={{
                                    //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    disabled
                                />
                            </div>}
                        {/* <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>Montant</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={calculateMontantTotalOfOneAstreinteReg(astreinte,isMontant,role,tj,tjClient)}
                                iconEnd={'€'}
                                //name="montantAstreinte"
                                disabled
                            />
                        </div> */}
                        {!disabledParam &&
                        <div className='FrameBox5Reg'>
                            <IconButton
                                onClick={(e) => {
                                    // e.preventDefault()
                                    // delete the index element by distructuring the array in two part without taking the i element
                                    let newArr = [
                                        ...astreintes.slice(0, i),
                                        ...astreintes.slice(i + 1, astreintes.length),
                                    ];
                                    // let newArr = [...experienceState]; // copying the old datas array
                                    // replace e.target.value with whatever you want to change it to
                                    setAstreintes(newArr);
                                    console.log(e, astreintes);
                                }}
                            >
                                <DeleteForeverIcon />
                            </IconButton>
                        </div>
                        }
                    </div>
                ))}
                <div style={{ display: 'flex', flexDirection:device=='desktop'? 'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {!disabledParam &&
                            <Button
                                onClick={(e) => {
                                    let index = astreintes.length;
                                    let newArr = [...astreintes]; // copying the old datas array
                                    newArr.push(initializeAstreinteRegularisation(index));
                                    setAstreintes(newArr);
                                    console.log(e, astreintes);
                                }}
                                //style={{
                                //    fontFamily: 'Lato',
                                //    fontStyle: 'normal',
                                //    fontWeight: 400,
                                //    fontSize: '16px',
                                //    height: '50px',
                                //    letterSpacing: '-0.0044em',
                                //}}
                                style={{...buttonStyles(false)}}
                                startIcon={<AddIcon />}
                            >{i18n.t('Ajouter une Astreinte')}</Button>}
                    </div>
                    <div
                        className="FrameBox7Reg FrameBoxGapReg"
                        style={{marginRight: role=='admin'? '56px' :'0px',flexDirection:device=='desktop'?'row':'column'}}
                    >
                        {role !== 'expert' &&
                            <div
                                className="FrameBox8Reg FrameBox18Reg"
                                style={role == 'admin' ? {width:device=='desktop'?'50%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Total des astreintes/Client')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    //InputProps={{
                                    //    endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'> <InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    name="totalAstreinteClient"
                                    value={totalAstreintesClient.toFixed(2)}
                                    disabled
                                />
                            </div>}
                        {role !== 'client' &&
                            <div
                                className="FrameBox8Reg FrameBox18Reg"
                                style={role == 'admin' ? {width:device=='desktop'?'50%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Total des astreintes/Expert')}</label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    //InputProps={{
                                    //    endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    name="totalAstreinteExpert"
                                    value={totalAstreintesExpert.toFixed(2)}
                                    disabled
                                />
                            </div>}

                    </div>

                    {/* <div
                        style={{
                            display: 'flex',
                            padding: '0px',
                            paddingRight: role=='admin' ? '56px' :'0px',
                            width: device=='desktop'?'27.5%':'100%',
                            gap: '16px',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                        }}
                    >
                        <label className='AjouterDiplomeFrame7'>Total des astreintes</label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            style={{ width: '100%', background: 'white', }}
                            value={totalAstreintes}
                            disabled
                            name="tauxJournalierExpert"
                        />
                    </div> */}
                </div>
            </div>
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('HNO')}
                </h6>
                {Array.isArray(hnos) && hnos.map((hno, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type de HNO')} </label>
                            <SelectComponent
                                // defaultValue={hno?.type}
                                val={hno?.type}
                                setVal={(e) => {
                                    let newArr = [...hnos];
                                    newArr[i].type = e.target.value;
                                    newArr[i].coefficient = prestationsComplementairesCLientData?.hnos?.find(item => item.label === e.target.value)?.montant;
                                    setHnos(newArr);
                                }}
                                listVal={prestationsComplementairesCLientData?.hnos}
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'> {i18n.t('Ajouter/déduire')} </label>
                            <SelectComponent
                                name='ajoutHno'
                                // defaultValue={hno?.ajout}
                                val={hno?.ajout}
                                setVal={(e) => {
                                    let newArr = [...hnos];
                                    newArr[i].ajout = e.target.value;
                                    setHnos(newArr);
                                    console.log(e.target.value);
                                }}
                                listVal={AjoutDeduire}
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg"
                            style={role == 'admin' ? {width:device=='desktop'?'20%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Nombre d\'heures')} </label>
                            <TextFieldComponent
                                //type='number'
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={hno?.nbrHeure}
                                onChange={(e) => {
                                    let newArr = [...hnos];
                                    newArr[i].nbrHeure = e.target.value;
                                    setHnos(newArr);
                                }}
                                name="nbrHeure"
                                disabled={disabledParam}
                            />
                        </div>
                        {role != 'expert' &&
                            <div
                                className="FrameBox4Reg"
                                style={role == 'client' ? {width:device=='desktop'?'25%':'100%'} : {width:device=='desktop'?'20%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Montant/Client')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    value={calculateMontantTotalOfOneHnoReg({
                                        hno: hno,
                                        tj: tj,
                                        tjClient: tjClient,
                                        role: 'client',
                                        nbrHrHno:nbrHrHno

                                    }).toFixed(2)}
                                    iconEnd={'€'}
                                    disabled
                                    name="montantClient"
                                />
                            </div>}
                        {role != 'client' &&
                            <div
                                className="FrameBox4Reg"
                                style={role == 'expert' ? {width:device=='desktop'?'25%':'100%'} : {width:device=='desktop'?'20%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Montant/Expert')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    value={calculateMontantTotalOfOneHnoReg({
                                        hno: hno,
                                        tj: tj,
                                        tjClient: tjClient,
                                        role: 'expert',
                                        nbrHrHno:nbrHrHno
                                    }).toFixed(2)}
                                    //InputProps={{
                                    //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    disabled
                                    name="montantExpert"
                                />
                            </div>}
                        {!disabledParam &&
                            <div className='FrameBox5Reg'>
                                <IconButton
                                    onClick={(e) => {
                                        let newArr = [
                                            ...hnos.slice(0, i),
                                            ...hnos.slice(i + 1, hnos.length),
                                        ];
                                        setHnos(newArr);
                                        console.log(e, hnos);
                                    }}
                                >
                                    <DeleteForeverIcon />
                                </IconButton>
                            </div>
                        }
                    </div>
                ))}
                <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {!disabledParam &&
                            <Button
                                onClick={(e) => {
                                    let index = hnos.length;
                                    let newArr = [...hnos]; // copying the old datas array
                                    newArr.push(initializeHNORegularisation(index));
                                    setHnos(newArr);
                                    console.log(e, hnos);
                                }}
                                //style={{
                                //    fontFamily: 'Lato',
                                //    fontStyle: 'normal',
                                //    fontWeight: 400,
                                //    fontSize: '16px',
                                //    letterSpacing: '-0.0044em',
                                //}}
                                style={{...buttonStyles(false)}}
                                startIcon={<AddIcon />}
                            >{i18n.t('Ajouter une HNO')}</Button>}
                    </div>
                    <div
                        className="FrameBox7Reg FrameBoxGapReg"
                        style={{marginRight: role=='admin'? '56px' :'0px',flexDirection:device=='desktop'?'row':'column'}}
                    >
                        {role !== 'expert' &&
                            <div
                                className="FrameBox8Reg FrameBox18Reg"
                                style={role == 'admin' ? {width:device=='desktop'?'50%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Total des HNO/Client')} </label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    //InputProps={{
                                    //    endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'> <InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    name="totalHnoClient"
                                    value={totalHnosClient.toFixed(2)}
                                    disabled
                                />
                            </div>}
                        {role !== 'client' &&
                            <div
                                className="FrameBox8Reg FrameBox18Reg"
                                style={role == 'admin' ? {width:device=='desktop'?'50%':'100%'} : {width:device=='desktop'?'25%':'100%'}}
                            >
                                <label className='AjouterDiplomeFrame7'>{i18n.t('HNO/Expert')}</label>
                                <IconTextField
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    //InputProps={{
                                    //    endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                    //}}
                                    iconEnd={'€'}
                                    name="totalHnoExpert"
                                    value={totalHnosExpert.toFixed(2)}
                                    disabled
                                />
                            </div>}

                    </div>
                </div>
            </div>

            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Notes de frais')}
                </h6>
                {Array.isArray(notesFrais) && notesFrais.map((noteFrai, i) => (
                    <div
                        className="FrameBox1Reg"
                        key={i}
                    >
                        <div
                            className="FrameBox4Reg FrameBox9Reg"
                            style={{width:device=='desktop'?'33.2%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Type du note de frais')} </label>
                            <TextFieldComponent
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={noteFrai?.type}
                                onChange={(e) => {
                                    let newArr = [...notesFrais];
                                    newArr[i].type = e.target.value;
                                    setNotesFrais(newArr);
                                }}
                                name="tauxJournalierExpert"
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg FrameBox9Reg"
                            style={{width:device=='desktop'?'33.2%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Ajouter/déduire')}</label>
                            <SelectComponent
                                name='typeDiplome'
                                val={noteFrai?.ajout}
                                setVal={(e) => {
                                    let newArr = [...notesFrais];
                                    newArr[i].ajout = e.target.value;
                                    if (newArr[i].ajout == 'deduire' && newArr[i].montant > 0) {
                                        newArr[i].montant = newArr[i].montant * (-1);
                                    }
                                    if (newArr[i].ajout == 'ajouter' && newArr[i].montant < 0) {
                                        newArr[i].montant = newArr[i].montant * (-1);
                                    }
                                    setNotesFrais(newArr);
                                    console.log(e.target.value);
                                }}
                                listVal={AjoutDeduire}
                                disabled={disabledParam}
                            />
                        </div>
                        <div
                            className="FrameBox4Reg FrameBox9Reg"
                            style={{width:device=='desktop'?'33.2%':'100%'}}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant')}</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                value={noteFrai?.montant}
                                iconEnd={'€'}
                                onChange={(e) => {
                                    let newArr = [...notesFrais];
                                    if (newArr[i].ajout == 'deduire' && newArr[i].montant > 0)
                                        newArr[i].montant = e.target.value * (-1);
                                    else if (newArr[i].ajout == 'ajouter' && newArr[i].montant < 0)
                                        newArr[i].montant = e.target.value * (-1);
                                    else
                                        newArr[i].montant = e.target.value;
                                    setNotesFrais(newArr);
                                }}
                                name="tauxJournalierExpert"
                                disabled={disabledParam}
                            />
                        </div>
                        {!disabledParam &&
                            <div className='FrameBox5Reg'>
                                {/*<IconButton
                                    onClick={(e) => {
                                        let index = notesFrais.length;
                                        let newArr = [...notesFrais]; // copying the old datas array
                                        newArr.push(initializeNotesFrais(index));
                                        setNotesFrais(newArr);
                                        console.log(e, notesFrais);
                                    }}
                                >
                                    <AddIcon />
                                </IconButton>*/}

                                <IconButton
                                    onClick={(e) => {
                                        // e.preventDefault()
                                        // delete the index element by distructuring the array in two part without taking the i element
                                        let newArr = [
                                            ...notesFrais.slice(0, i),
                                            ...notesFrais.slice(i + 1, notesFrais.length),
                                        ];
                                        // replace e.target.value with whatever you want to change it to
                                        setNotesFrais(newArr);
                                        console.log(e, notesFrais);
                                    }}
                                >
                                    <DeleteForeverIcon />
                                </IconButton>
                            </div>
                        }

                    </div>
                ))}
                <div style={{ display: 'flex', flexDirection:device=='desktop'? 'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {!disabledParam &&
                            <Button
                                onClick={(e) => {
                                    let index = notesFrais.length;
                                    let newArr = [...notesFrais]; // copying the old datas array
                                    newArr.push(initializeNotesFrais(index));
                                    setNotesFrais(newArr);
                                    console.log(e, notesFrais);
                                }}
                                //style={{
                                //    fontFamily: 'Lato',
                                //    fontStyle: 'normal',
                                //    fontWeight: 400,
                                //    fontSize: '16px',
                                //    letterSpacing: '-0.0044em',
                                //}}
                                style={{...buttonStyles(false)}}
                                startIcon={<AddIcon />}
                            >{i18n.t('Ajouter une note de frais')}</Button>}
                    </div>
                    <div
                        className="FrameBox7Reg "
                        style={{ width: device=='desktop'?'30.5%':'100%',marginRight:role=='admin'?'56px':'0px' }}
                    >
                        <div
                            className="FrameBox8Reg"
                            style={{ width: '100%' }}
                        >
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Total des notes de frais')} </label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                value={totalNotesFrais ? totalNotesFrais.toFixed(2): parseInt(0).toFixed(2)}
                                name="totalNotesFrais"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Montant total de la régularisation')}
                </h6>
                <div className="FrameBox1Reg FrameBox11Reg">
                    {role!='client' &&
                        <div className="FrameBox4Reg FrameBox9Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant total HT /Expert')}</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                value={montantTotalExpert ? montantTotalExpert.toFixed(2) : parseInt(0).toFixed(2)}
                                disabled
                                name="montantTotalClient"
                            />
                        </div>
                    }
                    {role!='expert' &&
                        <div className="FrameBox4Reg FrameBox9Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant total/Client')}</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                disabled
                                value={montantTotalClient ? montantTotalClient.toFixed(2) : parseInt(0).toFixed(2)}
                                name="montantTotalExpert"
                            />
                        </div>
                    }
                </div>
            </div>
            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Ajouter des détails')}
                </h6>
                <div className="FrameBox12Reg">
                    <TextFieldComponent
                        multiline
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        value={note}
                        onChange={(e) => {
                            setNote(e.target.value);
                        }}
                        placeholder="Ajouter des détails"
                        style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                        rows={4}
                        maxRows={5}
                        disabled={disabledParam}
                    />
                    <Stack spacing={5}>
                        {!disabledParam &&
                            <MultipleFilesUpload
                                PreviousFiles={fileList}
                                setFiles={setFileList}
                            />}
                        {Array.isArray(fileList) && fileList.length > 0 &&
                            <FileList
                                list={fileList}
                                setlist={setFileList}
                                mode={disabledParam ? 'readOnly' : ''}
                            />
                        }
                    </Stack>
                </div>
            </div>

            {!disabledParam &&
                <div className="FrameBox3Reg">
                    <Button
                        variant="outlined"
                        style={{...buttonStyles(false),...{width:device=='desktop'?'auto':'100%'}}}

                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        {i18n.t('Annuler')}
                    </Button>

                    {state?.rowData?.refCra ?
                        <Button
                            variant="contained"
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}

                            onClick={(e) => {
                                e.preventDefault();
                                createRegularisationX();
                            }}
                        >
                            {i18n.t('Modifier')}
                        </Button>
                        :
                        <Button
                            variant="contained"
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}

                            onClick={(e) => {
                                e.preventDefault();
                                createRegularisationX();
                            }}
                        >
                            {i18n.t('Valider')}
                        </Button>
                    }
                </div>}

        </form>

    );

};
export default RegularizationPC;